export default {
  en: {
    fail_login_message_1: "Invalid email or password.",
    fail_login_message_2: " Please check your credentials and try again.",

    fail_email_verify_message: "Please enter the correct verification code.",


    error_email_format: "Please enter a valid email address",
    no_input_email: "Please enter your email address",

    no_process_email_verify: "Please verify your email address",
    no_process_password_check: "Please check your password.",
    no_process_agree_term: "Please agree to the Terms of Service and Privacy Policy.",

    no_correct_password: "Passwords don't match.",
    no_format_password: "8+ characters with letters, numbers & symbols",
    no_input_password: "Please enter your password.",

    allow_format_message: "File format not supported. Only {0} files can be uploaded",

    expired_verfiy_time_message: "Verification code expired.",
    already_email_message: "Email already registered.",
    no_email_message: "Email not registered.",
    success_send_verify_code_message: "Verification code sent",
    success_verify_message: "Email verification completed.",
    no_process_name: "Please enter your name.",
    success_signup_message: "Sign-up completed.",
    success_reset_password: "Password has been changed.",
    success_update_user_data: "Changes have been saved..",


    expired_usage_count: "You've used all your credits.",
    expired_usage_storage: "Storage limit exceeded.",
    expired_plan: "구독 정보가 만료되었습니다.",

    confirm_delete_account: "Are you sure you want to delete your account?",
    confirm_delete_desc: "This action cannot be undone\nand all your data will be permanently deleted.",
    success_delete_account: "Account deleted successfully.\nThank you for using PM AutoTwin.\nHope to see you again! 🤗",

    please_fill_field: "Please fill in this field.",
    please_select_option: 'Please select an option.',
    please_select_options: 'Please select an options.',

    maximum_once_size: "Maximum upload size is {0}MB.",

    success_feedback: "Survey Completed!<br/>Thank you for your valuable feedback.<br/>10 additional credits have been added to your account.",

    analyze_fail_message: "Unable to read file.<br/>The file may be corrupted or not in the correct format.",
  },
  ko: {
    fail_login_message_1: "이메일 또는 비밀번호가 잘못되었습니다.",
    fail_login_message_2: "이메일과 비밀번호를 정확히 입력해 주세요.",

    fail_login_require_reset_message_1: "이 계정은 Google로 로그인하거나 “비밀번호 재설정”으로",
    fail_login_require_reset_message_2: "비밀번호를 재설정해야만 로그인할 수 있습니다.",

    fail_email_verify_message: "인증 번호를 다시 입력해 주세요.",


    error_email_format: "올바른 이메일 주소를 입력해주세요.",
    no_input_email: "이메일 주소를 입력해주세요.",

    no_process_email_verify: "이메일 인증을 완료해주세요.",
    no_process_password_check: "비밀번호를 확인해주세요.",
    no_process_agree_term: "이용 약관 및 개인정보처리방침에 동의해주세요.",

    no_correct_password: "비밀번호가 일치하지 않습니다.",
    no_format_password: "영문, 숫자, 특수문자 포함 8자 이상",
    no_input_password: "비밀번호를 입력해주세요.",

    allow_format_message: "지원되지 않는 파일 형식입니다. {0} 파일만 가능합니다.",

    expired_verfiy_time_message: "인증시간이 만료되었습니다.",
    already_email_message: "이미 가입된 이메일입니다.",
    no_email_message: "등록되지 않은 이메일입니다",
    success_send_verify_code_message: "인증번호를 발송했습니다.",
    success_verify_message: "이메일 인증이 완료되었습니다.",
    no_process_name: "이름을 입력해주세요.",
    success_signup_message: "회원가입이 완료되었습니다.",
    success_reset_password: "비밀번호가 변경되었습니다.",
    success_update_user_data: "변경이 완료되었습니다.",


    expired_usage_count: "크레딧을 모두 사용하셨습니다.",
    expired_usage_storage: "사용 용량을 초과하였습니다.",
    expired_plan: "구독 정보가 만료되었습니다.",

    confirm_delete_account: "정말로 계정을 삭제하시겠습니까?",
    confirm_delete_desc: "이 작업은 되돌릴 수 없으며,\n모든 데이터가 영구적으로 삭제됩니다.",
    success_delete_account: "계정 삭제가 완료되었습니다.\nPM AutoTwin을 이용해 주셔서 감사합니다.\n다시 만날 수 있길 기대해요. 🤗",

    please_fill_field: "해당 항목을 입력해주세요.",
    please_select_option: '해당 항목을 선택해주세요.',
    please_select_options: '해당 항목을 선택해주세요.',

    maximum_once_size: "최대 {0}MB까지 업로드 가능합니다.",

    success_feedback: "설문조사가 완료되었습니다!<br/>소중한 의견을 주셔서 감사합니다.<br/>추가 크레딧 10개가 지급되었습니다.",

    analyze_fail_message: "파일을 읽을 수 없습니다.<br/>파일이 손상되었거나 올바른 형식이 아닙니다.",
  },
  ja: {
    fail_login_message_1: "メールアドレスまたはパスワードが正しくありません。",
    fail_login_message_2: "メールアドレスとパスワードを正確に入力してください。",

    fail_email_verify_message: "認証番号を再度入力してください。",


    error_email_format: "正しいメールアドレスを入力してください。",
    no_input_email: "メールアドレスを入力してください。",

    no_process_email_verify: "メール認証を完了してください。",
    no_process_password_check: "パスワードを確認してください。",
    no_process_agree_term: "利用規約及び個人情報処理方針に同意してください。",

    no_correct_password: "パスワードが一致しません。",
    no_format_password: "英文、数字、特殊文字を含む8文字以上",
    no_input_password: "パスワードを入力してください",

    allow_format_message: "サポートされていないファイル形式です。{0}ファイルのみアップロード可能です。",

    expired_verfiy_time_message: "認証時間が期限切れになりました。",
    already_email_message: "すでに登録されているメールアドレスです。",
    no_email_message: "登録されていないメールアドレスです。",
    success_send_verify_code_message: "認証番号を送信しました。",
    success_verify_message: "メール認証が完了しました。",
    no_process_name: "名前を入力してください。",
    success_signup_message: "会員登録が完了しました。",
    success_reset_password: "パスワードが変更されました。",
    success_update_user_data: "変更が完了しました。",


    expired_usage_count: "クレジットをすべて使用しました。",
    expired_usage_storage: "使用容量を超過しました。",
    expired_plan: "구독 정보가 만료되었습니다.",

    confirm_delete_account: "本当にアカウントを削除しますか?",
    confirm_delete_desc: "この操作は取り消せず\nすべてのデータが完全に削除されます。",
    success_delete_account: "アカウント削除が完了しました。\nPM AutoTwinをご利用いただきありがとうございました。\nまた再びお会いできることを期待しています。🤗",

    please_fill_field: "項目を入力してください。",
    please_select_option: '項目を選択してください。.',
    please_select_options: '項目を選択してください。',

    maximum_once_size: "最大{0}MBまでアップロード可能です",

    success_feedback: "アンケートが完了しました!<br/>貴重なご意見をありがとうございます。<br/>追加クレジット10個が支給されました。",

    analyze_fail_message: "ファイルを読み込めません。<br/>>ファイルが破損しているか、正しい形式ではありません。",
  },
};
